<template>
  <div class="mt-2">
    <WarningDisable permission="open_port" />
    <div class="flex gap-6">
      <div>
        <form
          class="mb-4 space-y-4"
          @submit="submit_without_reloading"
          @reset="keyword = undefined"
        >
          <div class="space-y-2">
            <div>
              <legend>Từ khóa</legend>
              <label class="input w-full md:w-fit 2xl:w-fit">
                <i
                  class="fa-solid fa-magnifying-glass text-base-content/80"
                ></i>
                <input
                  type="text"
                  placeholder="Tìm kiếm theo từ khóa"
                  name="keyword"
                  v-model="keyword"
                />
              </label>
            </div>
            <div>
              <legend>Giao thức</legend>
              <div class="flex flex-col flex-wrap gap-1">
                <input
                  class="btn w-fit"
                  type="checkbox"
                  name="protocol"
                  aria-label="TCP"
                  v-model="selected_protocols"
                  value="TCP"
                />
                <input
                  class="btn w-fit"
                  type="checkbox"
                  name="protocol"
                  aria-label="UDP"
                  v-model="selected_protocols"
                  value="UDP"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap gap-2">
            <input
              class="btn btn-outline grow"
              type="reset"
              value="&#8635; Đặt lại"
              :disabled="open_port_store.loading.get_open_ports"
            />
            <button
              class="btn btn-primary btn-outline grow"
              type="submit"
              :disabled="
                !filter_has_changed || open_port_store.loading.get_open_ports
              "
            >
              &#10003; Áp dụng
            </button>
          </div>
        </form>
      </div>

      <div class="flex grow flex-col overflow-x-auto">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Danh sách cổng mở
        </div>
        <Loading v-if="open_port_store.loading.get_open_ports" />
        <template v-else-if="open_port_store.total_filter > 0">
          <div class="bg-base-100 mb-4 overflow-x-auto">
            <table class="table-pin-rows table-md table">
              <thead>
                <tr>
                  <th></th>
                  <th>Giao thức</th>
                  <th>Địa chỉ cục bộ</th>
                  <th>Cổng cục bộ</th>
                  <th>Địa chỉ từ xa</th>
                  <th>Cổng từ xa</th>
                  <th>Trạng thái</th>
                  <th>Thời gian tạo</th>
                </tr>
              </thead>
              <tbody class="bg-base-200">
                <tr
                  v-for="(port, idx) in open_port_store.open_port"
                  :key="port.id"
                >
                  <th>
                    {{
                      idx +
                      1 +
                      (number_from_query("page", 1) - 1) *
                        number_from_query("size", 24)
                    }}
                  </th>
                  <td>{{ port.protocol }}</td>
                  <td>{{ port.local_address }}</td>
                  <td>{{ port.local_port }}</td>
                  <td>{{ port.remote_address }}</td>
                  <td>{{ port.remote_port }}</td>
                  <td>{{ port.state }}</td>
                  <td>{{ dayjs(port.created).fromNow() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <Pagination :total_pages="open_port_store.total_pages" />
        </template>
        <NotFound v-else />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { array_from_query, number_from_query, str_from_query } from "@/api";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import { router } from "@/router/router";
import dayjs from "dayjs";
import { computed, ref } from "vue";
import WarningDisable from "../WarningDisable.vue";
import { use_open_port } from "./useOpenPort";

const init_keyword = computed(() => str_from_query("keyword"));
const init_protocols = computed<string[]>(() =>
  array_from_query("protocol", String),
);

const keyword = ref<string | undefined>(init_keyword.value);
const selected_protocols = ref<string[]>(init_protocols.value);
const filter_has_changed = computed(
  () =>
    JSON.stringify(selected_protocols.value) !=
      JSON.stringify(init_protocols.value) ||
    keyword.value !== init_keyword.value,
);
const open_port_store = use_open_port();

const submit_without_reloading = (e: Event) => {
  e.preventDefault();
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      keyword: keyword.value,
      protocol: selected_protocols.value,
    },
  });
};
</script>
